import { call } from "redux-saga/effects"

const log = msg => console.log(msg)

export function* startup(api, action) {
  yield call(log, "startup")
}



// WEBPACK FOOTER //
// ./src/sagas/startup.sagas.js